import { render, staticRenderFns } from "./Organizacion.vue?vue&type=template&id=6bec17b6"
import script from "./Organizacion.vue?vue&type=script&lang=js"
export * from "./Organizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bec17b6')) {
      api.createRecord('6bec17b6', component.options)
    } else {
      api.reload('6bec17b6', component.options)
    }
    module.hot.accept("./Organizacion.vue?vue&type=template&id=6bec17b6", function () {
      api.rerender('6bec17b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/Organizacion.vue"
export default component.exports